import { FormattedMessage } from "react-intl";
import useFormatPrice from "hooks/useFormatPrice";
import { OrderType } from "types/orderType";
import { CancelFeeCheckResponse } from "services/paymentService";
import KakaoAccordion from "components/coupon/KakaoAccordion";
import useLanguages from "hooks/useLanguages";
import CardLayout from "components/layout/CardLayout";

interface RelatedProductProps {
  order: OrderType;
  cancelFee?: CancelFeeCheckResponse;
}

const RelatedProduct = ({ order, cancelFee }: RelatedProductProps) => {
  console.log("[RelatedProduct] order", order);
  const { isKorean } = useLanguages();
  const formatPrice = useFormatPrice();
  const showDeliveryStatusChip =
    order.orderStatus === "COMPLETE" || order.orderStatus === "CANCELED";
  const deliveryStatus = order.goodsList?.deliveryStatus;
  // const deliveryStatusLabel =
  //   order.orderStatus === "CANCELED"
  //     ? deliveryStatus === "COMPLETE"
  //       ? "등록 완료"
  //       : null
  //     : deliveryStatus === "COMPLETE"
  //       ? "등록 완료"
  //       : deliveryStatus === "PENDING"
  //         ? "등록 가능"
  //         : null;
  const REGISTERED = isKorean ? "등록 완료" : "Registered";
  const AVAILABLE = isKorean ? "등록 가능" : "Available";

  const deliveryStatusLabel =
    order.orderStatus === "CANCELED"
      ? deliveryStatus === "COMPLETE"
        ? REGISTERED
        : null
      : deliveryStatus === "COMPLETE"
        ? REGISTERED
        : deliveryStatus === "PENDING"
          ? AVAILABLE
          : null;

  return (
    <CardLayout>
      <div className="mb-2 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <p className="font-bold">{isKorean ? order.goodsList?.name : "Lacha T Voucher"}</p>
          {showDeliveryStatusChip && deliveryStatusLabel && (
            <span className="rounded-full bg-[#EAF1F2] px-2 py-0.5 text-xs font-bold text-[#536067]">
              {deliveryStatusLabel}
            </span>
          )}
        </div>
        <p className="font-bold">
          {formatPrice(order.goodsList?.price)}
          {isKorean && "권"}
        </p>
      </div>

      {cancelFee && cancelFee.errorMessage == null && (
        <div className="flex w-full items-center justify-between">
          <p>
            <FormattedMessage id="orders.cancelFee" />:
          </p>
          <p>
            {"1000".toLocaleString()}
            <FormattedMessage id="payment.koreanWon" />
          </p>
        </div>
      )}
      {/* 여기에 orderStatus따라 분기처리.. */}
      {!(order.orderStatus === "CANCELED") && (
        <KakaoAccordion 
        descriptionKey={order.goodsList?.description} 
        order={order}
        />
      )}
    </CardLayout>
  );
};

export default RelatedProduct;
